import React from 'react';
import { Music2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';

const Hero = () => {
  const scrollToReleases = () => {
    const element = document.getElementById('releases');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Matrix Rain Background */}
      <MatrixRain />
      
      {/* Animated background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#0a0a0a_1px,transparent_1px),linear-gradient(to_bottom,#0a0a0a_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)]"></div>
      
      {/* Green glow effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-green-500/20 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-green-400/10 rounded-full blur-[120px] animate-pulse delay-1000"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto pt-20">
        {/* Logo */}
        <div className="mb-8 flex justify-center animate-fade-in">
          <img 
            src="https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/cop9shjb_137756.png" 
            alt="Numerounosounds" 
            className="w-56 sm:w-72 md:w-80 h-auto drop-shadow-[0_0_50px_rgba(0,255,136,0.6)]"
          />
        </div>

        {/* SUBSCRIBE BUTTON - ANDROID COMPATIBLE */}
        <div className="mb-8 animate-fade-in">
          <a 
            href="/vip"
            className="inline-block px-8 py-3 bg-gradient-to-r from-red-600 to-red-700 text-yellow-400 rounded-lg font-bold text-xl sm:text-2xl hover:from-red-500 hover:to-red-600 transition-all duration-300 shadow-[0_0_30px_rgba(220,38,38,0.6)] hover:shadow-[0_0_50px_rgba(220,38,38,0.9)] animate-pulse-glow whitespace-nowrap"
            style={{ 
              textShadow: '1px 1px 3px rgba(0,0,0,0.9)'
            }}
          >
            🔥 SUBSCRIBE NOW 🔥
          </a>
          <p className="text-red-400 font-medium text-sm sm:text-base mt-3">
            £4.99/month • Exclusive tracks • Early access
          </p>
        </div>

        {/* Tagline */}
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 text-white tracking-wider animate-slide-up">
          UNDERGROUND
          <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
            DRUM & BASS
          </span>
          <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
            & JUNGLE
          </span>
        </h1>

        <p className="text-green-400/80 text-base sm:text-lg mb-4 font-semibold animate-fade-in-delay">
          Trusted by DJs across the UK underground scene
        </p>

        <p className="text-gray-400 text-lg sm:text-xl md:text-2xl mb-12 max-w-3xl mx-auto animate-fade-in-delay">
          Pushing the boundaries of sound. Heavy basslines. Hard-hitting drums. No compromises.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-delay-2">
          <button 
            onClick={scrollToReleases}
            className="group px-8 py-4 bg-green-500 text-black rounded-lg font-bold text-lg hover:bg-green-400 transition-all duration-300 shadow-[0_0_30px_rgba(0,255,136,0.5)] hover:shadow-[0_0_50px_rgba(0,255,136,0.8)] hover:scale-105 flex items-center gap-2"
          >
            <Music2 className="group-hover:rotate-12 transition-transform duration-300" />
            Listen Now
          </button>
          <button 
            onClick={() => document.getElementById('demo').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-transparent border-2 border-green-500 text-green-400 rounded-lg font-bold text-lg hover:bg-green-500/10 transition-all duration-300 hover:scale-105"
          >
            Submit Demo
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-green-500/50 rounded-full flex justify-center pt-2">
            <div className="w-1 h-3 bg-green-500 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
